import ButtonT from '@components/tailwind-components/Button/ButtonT';
import InputWithLabelT from '@components/tailwind-components/Input/InputWithLabelT';
import { useMfaSettings } from '@hooks/auth/useMFASettings';
import { useMfaEnableForm } from '@hooks/settings/account/useMFAEnableForm';
import type React from 'react';
import { useTranslation } from 'react-i18next';
import { useModal } from '../../../../hooks/modal/useModal';

export const Enable2FaModal: React.FC = () => {
  const { qrCode, name, key } = useMfaSettings();
  const { handleSubmit, control } = useMfaEnableForm();
  const { t } = useTranslation();
  const { hideModal } = useModal();

  return (
    <form className='tailwind-modal-form' onSubmit={handleSubmit}>
      <div className='tailwind-modal-body'>
        <p className='text-sm mb-2 italic'>
          {t('account-settings.2fa.modals.enable.instructions')}
        </p>
        <div className='flex flex-wrap'>
          <div className='w-full lg:w-4/12'>
            <img src={qrCode} alt='qr-code' />
          </div>
          <div className='w-full lg:w-8/12 pt-3 text-sm'>
            <div className='flex items-top'>
              <div className='w-2/12'>
                <p className='text-sm'>
                  {t('account-settings.2fa.modals.enable.labels.name')}:
                </p>
              </div>
              <div className='w-10/12'>
                <p className='text-sm'>{name}</p>
              </div>
            </div>
            <div className='flex items-top mt-3'>
              <div className='w-2/12'>
                <p className='text-sm'>
                  {t('account-settings.2fa.modals.enable.labels.type')}:
                </p>
              </div>
              <div className='w-10/12'>
                <p className='text-sm'>
                  {t('account-settings.2fa.modals.enable.time-based')}
                </p>
              </div>
            </div>
            <div className='flex items-top mt-3'>
              <div className='w-2/12'>
                <p className='text-sm'>
                  {t('account-settings.2fa.modals.enable.labels.key')}:
                </p>
              </div>
              <div className='w-10/12'>
                <p className='break-words text-sm'>{key}</p>
              </div>
            </div>
          </div>
        </div>
        <div className='grid grid-cols-1 gap-x-6 gap-y-2'>
          <div className='col-span-1'>
            <InputWithLabelT
              type='text'
              field='token'
              placeholder={t('account-settings.2fa.modals.enable.token')}
              label={t('account-settings.2fa.modals.enable.token')}
              id='token'
              control={control}
              options={{
                required: t('general.validation.required'),
                minLength: 6,
                maxLength: 6,
              }}
            />
          </div>
        </div>
      </div>
      <div className='tailwind-modal-footer'>
        <ButtonT
          type='button'
          styling='cancel'
          size='xs'
          rounding='md'
          onClick={() => {
            hideModal();
          }}>
          {t('general.buttons.cancel')}
        </ButtonT>
        <ButtonT type='submit' styling='primary' size='xs' rounding='md'>
          {t('account-settings.2fa.modals.enable.enable')}
        </ButtonT>
      </div>
    </form>
  );
};

export default Enable2FaModal;
